import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';
import getFetchOptions from 'utils/getFetchOptions';

export default function transferTests(
	fromUsers,
	destinationType,
	destinationId
) {
	return fetch(
		`${ENDPOINT_URL}/transfertests`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify({
				fromUsers,
				destinationType,
				destinationId,
			}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			Promise.reject(apiErrorHandling(err));
			return err.ok;
		});
}
